[
	{
		"brandId": "starbucks",
		"nameKo": "스타벅스",
		"categoryId": "food-cafe",
		"colorHex": "#00704A",
		"aliases": ["스타벅스", "starbucks"],
		"sortOrder": 1
	},
	{
		"brandId": "twosomeplace",
		"nameKo": "투썸플레이스",
		"categoryId": "food-cafe",
		"colorHex": "#A6192E",
		"aliases": ["투썸플레이스", "twosomeplace"],
		"sortOrder": 2
	},
	{
		"brandId": "ediya",
		"nameKo": "이디야",
		"categoryId": "food-cafe",
		"colorHex": "#3C78B4",
		"aliases": ["이디야", "ediya"],
		"sortOrder": 3
	},
	{
		"brandId": "megacoffee",
		"nameKo": "메가커피",
		"categoryId": "food-cafe",
		"colorHex": "#F0B323",
		"aliases": ["메가커피", "메가엠지씨커피"],
		"sortOrder": 4
	},
	{
		"brandId": "compose",
		"nameKo": "컴포즈커피",
		"categoryId": "food-cafe",
		"colorHex": "#F0B323",
		"aliases": ["컴포즈커피", "composecoffee"],
		"sortOrder": 5
	},
	{
		"brandId": "paikdabang",
		"nameKo": "빽다방",
		"categoryId": "food-cafe",
		"colorHex": "#F3C33B",
		"aliases": ["빽다방", "빽다방커피"],
		"sortOrder": 6
	},
	{
		"brandId": "parisbaguette",
		"nameKo": "파리바게뜨",
		"categoryId": "food-bakery",
		"colorHex": "#2A5CAA",
		"aliases": ["파리바게뜨", "parisbaguette"],
		"sortOrder": 7
	},
	{
		"brandId": "touslesjours",
		"nameKo": "뚜레쥬르",
		"categoryId": "food-bakery",
		"colorHex": "#6D9E4D",
		"aliases": ["뚜레쥬르", "touslesjours"],
		"sortOrder": 8
	},
	{
		"brandId": "bhc",
		"nameKo": "bhc",
		"categoryId": "food-chicken",
		"colorHex": "#F6B92B",
		"aliases": ["bhc"],
		"sortOrder": 9
	},
	{
		"brandId": "kyochon",
		"nameKo": "교촌치킨",
		"categoryId": "food-chicken",
		"colorHex": "#A35E28",
		"aliases": ["교촌", "교촌치킨", "kyochon"],
		"sortOrder": 10
	},
	{
		"brandId": "dominos",
		"nameKo": "도미노피자",
		"categoryId": "food-pizza",
		"colorHex": "#0072CE",
		"aliases": ["도미노피자", "dominos"],
		"sortOrder": 11
	},
	{
		"brandId": "mcdonalds",
		"nameKo": "맥도날드",
		"categoryId": "food-burger",
		"colorHex": "#D9232E",
		"aliases": ["맥도날드", "mcdonalds"],
		"sortOrder": 12
	},
	{
		"brandId": "lotteria",
		"nameKo": "롯데리아",
		"categoryId": "food-burger",
		"colorHex": "#E20B22",
		"aliases": ["롯데리아", "lotteria"],
		"sortOrder": 13
	},
	{
		"brandId": "gs25",
		"nameKo": "GS25",
		"categoryId": "daily-cvs",
		"colorHex": "#6A2C91",
		"aliases": ["gs25", "gs이십오"],
		"sortOrder": 14
	},
	{
		"brandId": "cu",
		"nameKo": "CU",
		"categoryId": "daily-cvs",
		"colorHex": "#6A2C91",
		"aliases": ["cu", "씨유"],
		"sortOrder": 15
	},
	{
		"brandId": "seveneleven",
		"nameKo": "세븐일레븐",
		"categoryId": "daily-cvs",
		"colorHex": "#00843D",
		"aliases": ["세븐일레븐", "seveneleven"],
		"sortOrder": 16
	},
	{
		"brandId": "emart24",
		"nameKo": "이마트24",
		"categoryId": "daily-cvs",
		"colorHex": "#F58220",
		"aliases": ["이마트24", "emart24"],
		"sortOrder": 17
	},
	{
		"brandId": "emart",
		"nameKo": "이마트",
		"categoryId": "daily-hypermarket",
		"colorHex": "#F58220",
		"aliases": ["이마트", "emart"],
		"sortOrder": 18
	},
	{
		"brandId": "homeplus",
		"nameKo": "홈플러스",
		"categoryId": "daily-hypermarket",
		"colorHex": "#E30613",
		"aliases": ["홈플러스", "homeplus"],
		"sortOrder": 19
	},
	{
		"brandId": "costco",
		"nameKo": "코스트코",
		"categoryId": "daily-hypermarket",
		"colorHex": "#005DAA",
		"aliases": ["코스트코", "costco"],
		"sortOrder": 20
	},
	{
		"brandId": "oliveyoung",
		"nameKo": "올리브영",
		"categoryId": "beauty-cosmetics",
		"colorHex": "#9ACD32",
		"aliases": ["올리브영", "oliveyoung"],
		"sortOrder": 21
	},
	{
		"brandId": "lalavla",
		"nameKo": "랄라블라",
		"categoryId": "beauty-cosmetics",
		"colorHex": "#F15A9E",
		"aliases": ["랄라블라", "lalavla"],
		"sortOrder": 22
	},
	{
		"brandId": "uniqlo",
		"nameKo": "유니클로",
		"categoryId": "shop-fashion",
		"colorHex": "#E60012",
		"aliases": ["유니클로", "uniqlo"],
		"sortOrder": 23
	},
	{
		"brandId": "musinsa",
		"nameKo": "무신사",
		"categoryId": "shop-online",
		"colorHex": "#111111",
		"aliases": ["무신사", "musinsa"],
		"sortOrder": 24
	},
	{
		"brandId": "29cm",
		"nameKo": "29CM",
		"categoryId": "shop-online",
		"colorHex": "#111111",
		"aliases": ["29cm"],
		"sortOrder": 25
	},
	{
		"brandId": "coupang",
		"nameKo": "쿠팡",
		"categoryId": "shop-online",
		"colorHex": "#E6372A",
		"aliases": ["쿠팡", "coupang"],
		"sortOrder": 26
	},
	{
		"brandId": "navershopping",
		"nameKo": "네이버쇼핑",
		"categoryId": "shop-online",
		"colorHex": "#03C75A",
		"aliases": ["네이버쇼핑", "navershopping"],
		"sortOrder": 27
	},
	{
		"brandId": "samsung",
		"nameKo": "삼성전자",
		"categoryId": "shop-electronics",
		"colorHex": "#1428A0",
		"aliases": ["삼성전자", "samsung"],
		"sortOrder": 28
	},
	{
		"brandId": "apple",
		"nameKo": "애플",
		"categoryId": "shop-electronics",
		"colorHex": "#555555",
		"aliases": ["애플", "apple"],
		"sortOrder": 29
	},
	{
		"brandId": "daiso",
		"nameKo": "다이소",
		"categoryId": "daily-household",
		"colorHex": "#E60012",
		"aliases": ["다이소", "daiso"],
		"sortOrder": 30
	},
	{
		"brandId": "aladin",
		"nameKo": "알라딘",
		"categoryId": "culture-book",
		"colorHex": "#E56B2F",
		"aliases": ["알라딘", "aladin"],
		"sortOrder": 31
	},
	{
		"brandId": "yes24",
		"nameKo": "YES24",
		"categoryId": "culture-book",
		"colorHex": "#159447",
		"aliases": ["yes24"],
		"sortOrder": 32
	},
	{
		"brandId": "megabox",
		"nameKo": "메가박스",
		"categoryId": "culture-movie",
		"colorHex": "#D31920",
		"aliases": ["메가박스", "megabox"],
		"sortOrder": 33
	},
	{
		"brandId": "cgv",
		"nameKo": "CGV",
		"categoryId": "culture-movie",
		"colorHex": "#E51C23",
		"aliases": ["cgv"],
		"sortOrder": 34
	},
	{
		"brandId": "lottecinema",
		"nameKo": "롯데시네마",
		"categoryId": "culture-movie",
		"colorHex": "#A6192E",
		"aliases": ["롯데시네마", "lottecinema"],
		"sortOrder": 35
	},
	{
		"brandId": "skt",
		"nameKo": "SK텔레콤",
		"categoryId": "home-telecom",
		"colorHex": "#E4002B",
		"aliases": ["sk텔레콤", "skt"],
		"sortOrder": 36
	},
	{
		"brandId": "kt",
		"nameKo": "KT",
		"categoryId": "home-telecom",
		"colorHex": "#ED1C24",
		"aliases": ["kt"],
		"sortOrder": 37
	},
	{
		"brandId": "lguplus",
		"nameKo": "LG유플러스",
		"categoryId": "home-telecom",
		"colorHex": "#A50034",
		"aliases": ["lg유플러스", "lguplus"],
		"sortOrder": 38
	},
	{
		"brandId": "kakao",
		"nameKo": "카카오",
		"categoryId": "culture-game",
		"colorHex": "#FEE500",
		"aliases": ["카카오", "kakao"],
		"sortOrder": 39
	},
	{
		"brandId": "petemart",
		"nameKo": "펫마트",
		"categoryId": "pet-supply",
		"colorHex": "#5E7355",
		"aliases": ["펫마트", "petemart"],
		"sortOrder": 40
	}
]
